export const formatNumber = (number, fixed = 2, returnNumeric) => {
  if (!number) return 0;
  if (returnNumeric) {
    return parseFloat(number.toFixed(fixed));
  }
  const numb = number
    .toFixed(fixed)
    .toString()
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  if (Number.isInteger(number)) {
    return numb.replace(',00', '');
  }

  return numb;
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
